// Kazakh translations
const translations = {
  common: {
    smartCity: 'Ақылды Қала',
    dashboard: 'Басқару тақтасы',
    map: 'Карта',
    analytics: 'Аналитика',
    settings: 'Параметрлер',
    profile: 'Профиль',
    profileSettings: 'Профиль параметрлері',
    notifications: 'Хабарландырулар',
    helpSupport: 'Көмек және қолдау',
    systemStatus: 'Жүйе күйі',
    search: 'Іздеу',
    signOut: 'Шығу',
    systemRunningNormally: 'Жүйе қалыпты жұмыс істеуде',
    viewAllNotifications: 'Барлық хабарландыруларды көру',
    toggleColorMode: 'Түс режимін ауыстыру',
    type: 'Түрі',
    sensors: 'Сенсорлар',
    coordinates: 'Координаттар',
    view: 'Қарау',
    details: 'Егжей-тегжейлі',
    active: 'Белсенді',
    inactive: 'Белсенді емес',
    maintenance: 'Техникалық қызмет көрсету',
    all: 'Барлығы',
    error: 'Қате',
    errorLoadingData: 'Деректерді жүктеу кезінде қате',
    refresh: 'Жаңарту',
    administrator: 'Әкімші',
    success: 'Сәтті',
    required: 'Бұл өріс міндетті',
    invalidValue: 'Жарамсыз мән',
    invalidRange: 'Мән жарамды ауқымнан тыс',
    operational: 'Жұмыс істейді',
    notOperational: 'Жұмыс істемейді',
    timestamp: 'Уақыт белгісі',
    deviceId: 'Құрылғы идентификаторы',
    lastUpdated: 'Соңғы жаңарту',
    exportData: 'Деректерді экспорттау',
    saveChanges: 'Өзгерістерді сақтау',
    updateFailed: 'Жаңарту сәтсіз аяқталды',
    errorLoadingLocation: 'Орналасу деректерін жүктеу қатесі',
    backToLocations: 'Орналасуларға қайту',
    description: 'Сипаттама',
    multiSelect: 'Көптік таңдау',
    clearSelection: 'Таңдауды тазарту',
    delete: 'Жою',
  },

  dashboard: {
    trafficOverview: 'Трафик шолуы',
    recentEvents: 'Соңғы оқиғалар',
    sensorStatus: 'Сенсор күйі',
    systemHealth: 'Жүйе денсаулығы',
    trafficVolume: 'Трафик көлемі',
    incidents: 'Оқиғалар',
    sensors: 'Сенсорлар',
    reports: 'Есептер',
    calendar: 'Күнтізбе',
    signalStatus: 'Сигнал күйі',
    averageTravelTime: 'Орташа саяхат уақыты',
    viewDetails: 'Егжей-тегжейлі қарау',
    viewAll: 'Барлығын көру',
    online: 'Желіде',
    offline: 'Желіден тыс',
    uptime: 'Жұмыс уақыты',
    responseTime: 'Жауап беру уақыты',
    dataPoints: 'Деректер нүктелері',
    lastUpdate: 'Соңғы жаңарту',

    // Added new location page translations
    addNew: 'Жаңа қосу',
    searchLocations: 'Орындарды іздеу...',
    filterByType: 'Түрі бойынша сүзу',
    filterByStatus: 'Күйі бойынша сүзу',
    grid: 'Тор',
    list: 'Тізім',
    noLocationsFound: 'Орындар табылмады',
    tryDifferentSearch: 'Басқа іздеу сұранысын немесе сүзгіні қолданып көріңіз',
    locationsDescription: 'Орындар туралы деректерді басқару және бақылау',

    // Add location modal translations
    addNewLocation: 'Жаңа орын қосу',
    locationNamePlaceholder: 'Орын атауын енгізіңіз',
    locationAddressPlaceholder: 'Мекен-жайын енгізіңіз',
    locationTypePlaceholder: 'Мысалы, қиылыс, тас жол т.б.',
    locationAddedSuccess: 'Орын сәтті қосылды',
    locationDeletedSuccess: 'Орын сәтті жойылды',
    locationDeleteFailed: 'Орынды жою сәтсіз аяқталды',
    deleteLocationsTitle: 'Орындарды жою',
    deleteLocationsConfirm: '{{count}} орынды жойғыңыз келе ме?',
    deleteLocationsWarning:
      'Бұл әрекетті кері қайтару мүмкін емес. Бұл орындарға қосылған барлық сенсорлар ажыратылады.',
    bulkDeleteSuccess: '{{count}} орын сәтті жойылды',
    bulkDeletePartialSuccess:
      'Жартылай сәтті: {{success}} орын жойылды, {{failed}} сәтсіз аяқталды',
    bulkDeleteFailed: 'Орындарды жою сәтсіз аяқталды',
    locationUpdatedSuccess: 'Орналасу сәтті жаңартылды',
    editLocationDesc: 'Орналасу деректері мен координаттарын өңдеу',
    locationDescriptionPlaceholder: 'Орналасу сипаттамасын енгізіңіз (міндетті емес)',
    locationsMap: 'Орналасу картасы',
  },

  // Жүйе параметрлері мен конфигурациялар
  settings: {
    dashboard: 'Параметрлер тақтасы',
    system: 'Жүйе параметрлері',
    user: 'Пайдаланушы параметрлері',
    organization: 'Ұйым параметрлері',
    security: 'Қауіпсіздік параметрлері',
    notifications: 'Хабарландыру параметрлері',
    integrations: 'Интеграция параметрлері',
    maintenance: 'Техникалық қызмет параметрлері',

    // Пайдаланушыларды басқару
    'User Management': 'Пайдаланушыларды басқару',
    'User Profiles': 'Пайдаланушы профильдері',
    'Role Management': 'Рөлдерді басқару',
    'Permission Settings': 'Рұқсат параметрлері',
    'Access Control': 'Қатынау бақылауы',
    'User Groups': 'Пайдаланушы топтары',
    Authentication: 'Аутентификация',
    'Session Management': 'Сессия басқаруы',

    // Жүйе конфигурациясы
    'System Configuration': 'Жүйе конфигурациясы',
    'General Settings': 'Жалпы параметрлер',
    'Performance Settings': 'Өнімділік параметрлері',
    'Database Settings': 'Деректер қоры параметрлері',
    'Cache Settings': 'Кэш параметрлері',
    'Logging Settings': 'Журналдау параметрлері',
    'Backup Settings': 'Сақтық көшірме параметрлері',
    'Import/Export': 'Импорт/Экспорт',

    // API және интеграция параметрлері
    'API Configuration': 'API конфигурациясы',
    'Rate Limiting': 'Жылдамдық шектеуі',
    'Webhook Settings': 'Webhook параметрлері',
    'External APIs': 'Сыртқы API',
    'Data Sync': 'Деректер синхронизациясы',
    'Protocol Settings': 'Протокол параметрлері',
    'Connection Testing': 'Қосылымды тексеру',
    'Integration Status': 'Интеграция күйі',

    // Хабарландыруларды басқару
    'Notification Types': 'Хабарландыру түрлері',
    'Email Settings': 'Электрондық пошта параметрлері',
    'SMS Settings': 'SMS параметрлері',
    'Push Notifications': 'Push-хабарландырулар',
    'Alert Preferences': 'Дабыл параметрлері',
    'Delivery Methods': 'Жеткізу әдістері',
    'Escalation Rules': 'Эскалация ережелері',
    'Notification Templates': 'Хабарландыру үлгілері',

    // Қауіпсіздік конфигурациясы
    'Password Policy': 'Құпия сөз саясаты',
    'Two-Factor Authentication': 'Екі факторлы аутентификация',
    'IP Restrictions': 'IP шектеулер',
    'SSL/TLS Settings': 'SSL/TLS параметрлері',
    'Encryption Settings': 'Шифрлау параметрлері',
    'Audit Logging': 'Аудит журналдары',
    'Compliance Settings': 'Сәйкестік параметрлері',
    'Security Monitoring': 'Қауіпсіздік мониторингі',

    // Деректерді басқару
    'Data Retention': 'Деректерді сақтау',
    'Data Archiving': 'Деректерді архивтеу',
    'Data Purging': 'Деректерді тазарту',
    'Data Quality': 'Деректер сапасы',
    'Data Sources': 'Деректер көздері',
    'Data Validation': 'Деректерді тексеру',
    'Data Migration': 'Деректер көшіру',
    'Data Backup': 'Деректер сақтық көшірмесі',

    // Қолданба параметрлері
    'Theme Settings': 'Тақырып параметрлері',
    'Language Settings': 'Тіл параметрлері',
    'Timezone Settings': 'Уақыт белдеуі параметрлері',
    'Display Settings': 'Көрсету параметрлері',
    'Layout Settings': 'Макет параметрлері',
    'Dashboard Preferences': 'Басқару тақтасы параметрлері',
    'Widget Configuration': 'Виджет конфигурациясы',
    'Chart Settings': 'Диаграмма параметрлері',

    // Жүйе мониторингі
    'Health Monitoring': 'Денсаулық мониторингі',
    'Performance Monitoring': 'Өнімділік мониторингі',
    'Resource Usage': 'Ресурстарды пайдалану',
    'System Alerts': 'Жүйе дабылдары',
    'Error Tracking': 'Қателерді қадағалау',
    'Diagnostic Tools': 'Диагностикалық құралдар',
    'System Status': 'Жүйе күйі',
    'Maintenance Windows': 'Техникалық қызмет терезелері',

    // Dashboard settings UI
    configurePreferences: 'Басқару тақтасы параметрлерін конфигурациялау',
    generalSettings: 'Жалпы параметрлер',
    displaySettings: 'Көрсету параметрлері',
    notificationSettings: 'Хабарландыру параметрлері',
    advancedSettings: 'Кеңейтілген параметрлер',
    language: 'Тіл',
    languages: {
      english: 'Ағылшын',
      russian: 'Орыс',
      kazakh: 'Қазақ',
    },
    theme: 'Тақырып',
    light: 'Жарық',
    dark: 'Қараңғы',
    systemDefault: 'Жүйелік',
    enableNotifications: 'Хабарландыруларды қосу',
    emailAlerts: 'Электрондық пошта ескертулері',
    dataRefreshInterval: 'Деректерді жаңарту аралығы (минут)',
    defaultMapView: 'Әдепкі карта көрінісі',
    trafficView: 'Трафик көрінісі',
    satelliteView: 'Спутниктік көрініс',
    streetsView: 'Көшелер көрінісі',
    darkView: 'Қараңғы көрініс',
    dashboardLayout: 'Басқару тақтасының макеті',
    grid: 'Тор',
    list: 'Тізім',
    compact: 'Ықшам',
    colorScheme: 'Түс схемасы',
    blue: 'Көк',
    green: 'Жасыл',
    purple: 'Күлгін',
    orange: 'Қызғылт сары',
    red: 'Қызыл',
    dataCardSize: 'Деректер картасының өлшемі',
    small: 'Кішкентай',
    medium: 'Орташа',
    large: 'Үлкен',
    showLegends: 'Диаграммаларда легендаларды көрсету',
    trafficIncidents: 'Жол оқиғалары',
    sensorOfflineAlerts: 'Сенсор оффлайн ескертулері',
    congestionAlerts: 'Кептеліс туралы ескертулер',
    systemUpdates: 'Жүйе жаңартулары',
    dailyReports: 'Күнделікті есептер',
    advancedUsersNote: 'Бұл параметрлер тәжірибелі пайдаланушыларға арналған.',
    apiKey: 'API кілті',
    apiKeyNote: 'Бұл кілт сыртқы интеграциялар үшін қолданылады.',
    developerMode: 'Әзірлеуші режимі',
    debuggingTools: 'Кеңейтілген түзету құралдарын қосады',
    dataRetention: 'Деректерді сақтау (күн)',
    logLevel: 'Журнал деңгейі',
    warning: 'Ескерту',
    info: 'Ақпарат',
    debug: 'Түзету',
    trace: 'Трассировка',
    betaFeatures: 'Бета функцияларды қосу',
    resetDefaults: 'Әдепкі параметрлерді қалпына келтіру',
    saveSettings: 'Параметрлерді сақтау',
    saving: 'Сақтау',
    general: 'Жалпы',
    integrationsTab: 'Интеграциялар',
    integrationsDescription:
      'Ақылды қала тақтасы үшін үшінші тарап интеграцияларын, API соңғы нүктелерін және өріс сәйкестіктерін конфигурациялаңыз.',
  },

  // Пайдаланушы интерфейсі және компоненттер
  ui: {
    navigation: 'Навигация',
    menu: 'Мәзір',
    toolbar: 'Құралдар тақтасы',
    sidebar: 'Бүйір панель',
    footer: 'Төменгі колонтитул',
    header: 'Жоғарғы колонтитул',
    breadcrumb: 'Навигация жолы',
    pagination: 'Беттеу',

    // Форма элементтері
    'Form Elements': 'Форма элементтері',
    'Input Fields': 'Енгізу өрістері',
    'Select Boxes': 'Таңдау жолақтары',
    'Check Boxes': 'Белгілеу жолақтары',
    'Radio Buttons': 'Радио батырмалары',
    'Text Areas': 'Мәтін аумақтары',
    'File Uploads': 'Файл жүктеу',
    'Date Pickers': 'Күн таңдағыштар',
    'Time Pickers': 'Уақыт таңдағыштар',

    // Батырмалар және әрекеттер
    'Primary Button': 'Негізгі батырма',
    'Secondary Button': 'Қосымша батырма',
    'Submit Button': 'Жіберу батырмасы',
    'Cancel Button': 'Бас тарту батырмасы',
    'Reset Button': 'Қалпына келтіру батырмасы',
    'Edit Button': 'Өңдеу батырмасы',
    'Delete Button': 'Жою батырмасы',
    'Save Button': 'Сақтау батырмасы',
    'Apply Button': 'Қолдану батырмасы',
    'Close Button': 'Жабу батырмасы',
    'Back Button': 'Артқа батырмасы',
    'Next Button': 'Келесі батырма',
    'Previous Button': 'Алдыңғы батырма',
    'Refresh Button': 'Жаңарту батырмасы',
    'Search Button': 'Іздеу батырмасы',
    'Clear Button': 'Тазарту батырмасы',
    'Export Button': 'Экспорт батырмасы',
    'Import Button': 'Импорт батырмасы',
    'Download Button': 'Жүктеп алу батырмасы',
    'Upload Button': 'Жүктеп берү батырмасы',

    // Модальды терезелер және диалогтар
    'Modal Dialog': 'Модальды терезе',
    'Confirmation Dialog': 'Растау диалогы',
    'Alert Dialog': 'Дабыл диалогы',
    'Info Dialog': 'Ақпарат диалогы',
    'Warning Dialog': 'Ескерту диалогы',
    'Error Dialog': 'Қате диалогы',
    'Success Dialog': 'Сәттілік диалогы',
    'Progress Dialog': 'Прогресс диалогы',

    // Деректерді көрсету
    'Data Table': 'Деректер кестесі',
    'Data Grid': 'Деректер торы',
    'List View': 'Тізім көрінісі',
    'Card View': 'Карточка көрінісі',
    'Tree View': 'Ағаш көрінісі',
    'Chart View': 'Диаграмма көрінісі',
    'Map View': 'Карта көрінісі',
    'Detail View': 'Толық көрініс',

    // Жүктеу және күй
    'Loading Spinner': 'Жүктеу индикаторы',
    'Progress Bar': 'Прогресс жолағы',
    'Status Indicator': 'Күй индикаторы',
    Badge: 'Белгі',
    Label: 'Белгі',
    Tag: 'Тег',
    Chip: 'Чип',
    Tooltip: 'Кеңес',

    // Макет және орналасу
    'Grid Layout': 'Тор макеті',
    'Flex Layout': 'Икемді макет',
    'Card Layout': 'Карточка макеті',
    'Panel Layout': 'Панель макеті',
    'Tab Layout': 'Қойынды макет',
    'Accordion Layout': 'Аккордеон макеті',
    'Sidebar Layout': 'Бүйір панель макеті',
    'Split Layout': 'Бөлінген макет',
  },

  map: {
    trafficSensors: 'Трафик сенсорлары',
    nearbyEvents: 'Жақын оқиғалар',
    fullScreen: 'Қолыптау',
    noEventsInArea: 'Бұл аймақта оқиғалар жоқ',
    sensorDetails: 'Сенсор туралы мәліметтер',
    status: 'Күйі',
    location: 'Орналасқан жері',
    lastReading: 'Соңғы көрсеткіштер',
    trafficFlow: 'Трафик ағыны',
    averageSpeed: 'Орташа жылдамдық',
  },

  analytics: {
    title: 'Аналитика тақтасы',
    timeRangeFilter: 'Уақыт аралығы',
    sensorType: 'Сенсор түрі',
    applyFilters: 'Сүзгілерді қолдану',
    trafficVolumeOverTime: 'Уақыт бойынша трафик көлемі',
    vehicleTypeDistribution: 'Көлік түрлерінің таралуы',
    congestionMetrics: 'Кептеліс метрикалары',
    averageDailyTraffic: 'Орташа күнделікті трафик',
    peakHourVolume: 'Шыңдық сағат көлемі',
    congestionIndex: 'Кептеліс индексі',
    // Time range options
    timeRange: {
      day: 'Соңғы 24 сағат',
      week: 'Соңғы 7 күн',
      month: 'Соңғы 30 күн',
    },
    metricType: {
      traffic: 'Трафик көлемі',
      speed: 'Көлік жылдамдығы',
      incidents: 'Жол оқиғалары',
    },
    metrics: {
      totalTraffic: 'Жалпы трафик көлемі',
      avgSpeed: 'Орташа жылдамдық',
      congestionLevel: 'Кептеліс деңгейі',
      incidentCount: 'Оқиғалар саны',
    },
    trafficByLocation: 'Орналасқан жері бойынша трафик',
    trafficTrends: 'Трафик тенденциялары',
    trafficPatterns: 'Трафик үлгілері',
    speedByLocation: 'Орналасқан жері бойынша жылдамдық',
    speedTrends: 'Уақыт бойынша жылдамдық тенденциялары',
    speedDistribution: 'Жылдамдық диапазонының таралуы',
    speedPatterns: 'Уақыт бойынша жылдамдық үлгілері',
    incidentsByLocation: 'Орналасқан жері бойынша оқиғалар',
    incidentTrends: 'Оқиға тенденциялары',
    incidentTypes: 'Оқиға түрлерінің таралуы',
    incidentPatterns: 'Оқиға үлгілері',
  },

  profile: {
    userProfile: 'Пайдаланушы профилі',
    editProfile: 'Профильді өңдеу',
    cancel: 'Болдырмау',
    saveChanges: 'Өзгерістерді сақтау',
    department: 'Бөлім',
    accessLevel: 'Қол жеткізу деңгейі',
    memberSince: 'Мүше болған күннен бастап',
    lastLogin: 'Соңғы кіру',
    personalInfo: 'Жеке ақпарат',
    security: 'Қауіпсіздік',
    activeSessions: 'Белсенді сессиялар',
    fullName: 'Толық аты',
    emailAddress: 'Электрондық пошта мекенжайы',
    phoneNumber: 'Телефон нөірі',
    bio: 'Өмірбаян',
    emailPrivacy: 'Біз сіздің электрондық поштаңызды ешқашан бөліспейміз.',
    password: 'Құпия сөз',
    lastPasswordChange: 'Соңғы өзгеріс 30 күн бұрын',
    changePassword: 'Құпия сөзді өзгерту',
    twoFactorAuth: 'Екі факторлы аутентификация',
    enabled: 'Қосылған',
    disabled: 'Өшірілген',
    enable: 'Қосу',
    disable: 'Өшіру',
    accountActivityNotifications: 'Аккаунт белсенділігі туралы хабарландырулар',
    willReceiveNotifications: 'Сіз аккаунт белсенділігі туралы хабарландырулар аласыз',
    wontReceiveNotifications: 'Сіз аккаунт белсенділігі туралы хабарландырулар алмайсыз',
    currentSessions: 'Ағымдағы белсенді сессиялар',
    sessionsDescription: 'Бұл сіздің аккаунтыңызға кірген құрылғылар.',
    lastAccessed: 'Соңғы қатынасу',
    terminate: 'Аяқтау',
    logoutAllDevices: 'Барлық құрылғылардан шығу',
  },

  notifications: {
    all: 'Барлығы',
    unread: 'Оқылмаған',
    read: 'Оқылған',
    archived: 'Мұрағатталған',
    markAsRead: 'Оқылған деп белгілеу',
    actions: 'Әрекеттер',
    markAsUnread: 'Оқылмаған деп белгілеу',
    archive: 'Мұрағаттау',
    delete: 'Жою',
    filterByType: 'Түрі бойынша сүзу',
    allTypes: 'Барлық түрлер',
    incident: 'Оқиға',
    system: 'Жүйе',
    maintenance: 'Техникалық қызмет көрсету',
    alert: 'Ескерту',
    info: 'Ақпарат',
    filterBySeverity: 'Маңыздылығы бойынша сүзу',
    allSeverities: 'Барлық маңыздылық',
    low: 'Төмен',
    medium: 'Орташа',
    high: 'Жоғары',
    critical: 'Критикалық',
    filterByStatus: 'Күйі бойынша сүзу',
    allStatuses: 'Барлық күйлер',
    selectAll: 'Барлығын таңдау',
    notificationsCount: 'хабарландырулар',
    noNotificationsFound: 'Сіздің сүзгілеріңізге сәйкес келетін хабарландырулар табылмады',
    actionRequired: 'Әрекет қажет',
    source: 'Көзі',
    relatedTo: 'Байланысты',
    noUnread: 'Оқылмаған хабарландырулар жоқ',
    noRead: 'Оқылған хабарландырулар жоқ',
    noArchived: 'Мұрағатталған хабарландырулар жоқ',
    justNow: 'Жаңа ғана',
    minutesAgo: '{{count}} минут бұрын',
    hoursAgo: '{{count}} сағат бұрын',
    yesterday: 'Кеше',
    daysAgo: '{{count}} күн бұрын',
  },

  search: {
    advancedSearch: 'Кеңейтілген іздеу',
    searchPlaceholder: 'Оқиғаларды, сенсорларды немесе орындарды іздеу...',
    search: 'Іздеу',
    moreFilters: 'Қосымша сүзгілер',
    lessFilters: 'Азырақ сүзгілер',
    activeFilters: 'Белсенді сүзгілер',
    clearAll: 'Барлығын тазалау',
    eventTypes: 'Оқиға түрлері',
    locations: 'Орындар',
    vehicleTypes: 'Көлік түрлері',
    car: 'Автокөлік',
    bus: 'Автобус',
    truck: 'Жүк көлігі',
    motorcycle: 'Мотоцикл',
    bicycle: 'Велосипед',
    speedRange: 'Жылдамдық диапазоны',
    customFilter: 'Арнайы сүзгі',
    eventType: 'Оқиға түрі',
    location: 'Орналасқан жері',
    timestamp: 'Уақыт белгісі',
    sensorType: 'Сенсор түрі',
    speed: 'Жылдамдық',
    status: 'Күйі',
    equals: 'Тең',
    contains: 'Құрамында',
    greaterThan: 'Үлкен',
    lessThan: 'Кіші',
    range: 'Диапазон',
    addFilter: 'Сүзгі қосу',
    results: 'Нәтижелер',
    selectEventType: 'Оқиға түрін таңдаңыз',
    selectLocation: 'Орынды таңдаңыз',
    selectSensorType: 'Сенсор түрін таңдаңыз',
    enterSpeed: 'Жылдамдықты км/сағ бірлігінде енгізіңіз',
    enterValue: 'Мәнді енгізіңіз',
  },

  events: {
    // ... existing translations ...
  },

  sensors: {
    // ... existing translations ...
  },

  reports: {
    // ... existing translations ...
  },

  calendar: {
    month: 'Ай',
    week: 'Апта',
    day: 'Күн',
    list: 'Тізім',
    addEvent: 'Оқиға қосу',
    eventDetails: 'Оқиға мәліметтері',
    title: 'Тақырып',
    description: 'Сипаттама',
    location: 'Орналасқан жері',
    startDate: 'Басталу күні мен уақыты',
    endDate: 'Аяқталу күні мен уақыты',
    allDay: 'Күні бойы',
    eventType: 'Оқиға түрі',
    priority: 'Басымдық',
    status: 'Күй',
    trafficEvent: 'Жол қозғалысы оқиғасы',
    maintenance: 'Техникалық қызмет көрсету',
    meeting: 'Кездесу',
    alert: 'Ескерту',
    other: 'Басқа',
    low: 'Төмен',
    medium: 'Орташа',
    high: 'Жоғары',
    pending: 'Күтуде',
    inProgress: 'Орындалуда',
    completed: 'Аяқталды',
    cancelled: 'Бас тартылды',
    save: 'Сақтау',
    delete: 'Жою',
    cancel: 'Болдырмау',
    loading: 'Күнтізбе жүктелуде...',
    eventCreated: 'Оқиға жасалды',
    eventUpdated: 'Оқиға жаңартылды',
    eventDeleted: 'Оқиға жойылды',
    assignees: 'Тағайындалғандар',
    yes: 'Иә',
    no: 'Жоқ',
    // FullCalendar specific translations
    currentDay: 'Бүгін',
    dayNames: ['Жексенбі', 'Дүйсенбі', 'Сейсенбі', 'Сәрсенбі', 'Бейсенбі', 'Жұма', 'Сенбі'],
    dayNamesShort: ['Жек', 'Дүй', 'Сей', 'Сәр', 'Бей', 'Жұм', 'Сен'],
    monthNames: [
      'Қаңтар',
      'Ақпан',
      'Наурыз',
      'Сәуір',
      'Мамыр',
      'Маусым',
      'Шілде',
      'Тамыз',
      'Қыркүйек',
      'Қазан',
      'Қараша',
      'Желтоқсан',
    ],
    monthNamesShort: [
      'Қаң',
      'Ақп',
      'Нау',
      'Сәу',
      'Мам',
      'Мау',
      'Шіл',
      'Там',
      'Қыр',
      'Қаз',
      'Қар',
      'Жел',
    ],
    buttonText: {
      today: 'Бүгін',
      month: 'Ай',
      week: 'Апта',
      day: 'Күн',
      list: 'Тізім',
    },
    allDayText: 'Күні бойы',
    moreLinkText: 'тағы',
    noEventsText: 'Көрсетілетін оқиғалар жоқ',
    // Add locale property for FullCalendar
    locale: 'kk',
  },

  integration: {
    apiKeys: 'API кілттері',
    createApiKey: 'API кілтін жасау',
    deleteApiKey: 'API кілтін жою',
    regenerateApiKey: 'API кілтін қайта жасау',
    apiKeyName: 'API кілтінің атауы',
    apiKeyValue: 'API кілтінің мәні',
    apiKeyCreated: 'API кілті жасалды',
    apiKeyDeleted: 'API кілті жойылды',
    apiKeyRegenerated: 'API кілті қайта жасалды',
    copyApiKey: 'API кілтін көшіру',
    confirmDeleteApiKey: 'Бұл API кілтін жойғыңыз келетініне сенімдісіз бе?',
    noApiKeys: 'API кілттері табылмады',

    endpoints: 'Соңғы нүктелер',
    createEndpoint: 'Соңғы нүкте жасау',
    deleteEndpoint: 'Соңғы нүктені жою',
    endpointName: 'Соңғы нүкте атауы',
    endpointUrl: 'Соңғы нүкте URL',
    endpointMethod: 'Әдіс',
    endpointCreated: 'Соңғы нүкте жасалды',
    endpointDeleted: 'Соңғы нүкте жойылды',
    noEndpoints: 'Соңғы нүктелер табылмады',

    fieldMappings: 'Өріс сәйкестіктері',
    createMapping: 'Сәйкестік жасау',
    deleteMapping: 'Сәйкестікті жою',
    mappingName: 'Сәйкестік атауы',
    sourceField: 'Бастапқы өріс',
    targetField: 'Мақсатты өріс',
    mappingCreated: 'Сәйкестік жасалды',
    mappingDeleted: 'Сәйкестік жойылды',
    noMappings: 'Өріс сәйкестіктері табылмады',

    testIntegrations: 'Интеграцияларды тексеру',
    savedTests: 'Сақталған тесттер',
    testConfiguration: 'Тест конфигурациясы',
    testName: 'Тест атауы',
    testDescription: 'Тест сипаттамасы',
    method: 'Әдіс',
    endpoint: 'Соңғы нүкте',
    headers: 'Тақырыптар',
    headerKey: 'Тақырып кілті',
    headerValue: 'Тақырып мәні',
    requestBody: 'Сұраныс денесі',
    jsonBody: 'JSON денесі',
    execute: 'Орындау',
    response: 'Жауап',
    testSaved: 'Тест сәтті сақталды',
    testDeleted: 'Тест сәтті жойылды',
    noSavedTests: 'Сақталған тесттер табылмады',
    requiredFields: 'Атау мен соңғы нүкте міндетті',
    endpointRequired: 'Соңғы нүкте міндетті',
  },

  users: {
    // ... existing translations ...
  },

  // Add sidebar translations
  sidebar: {
    app: {
      name: 'Ақылды Қала',
    },
    main: 'Басты',
    overview: 'Шолу',
    dashboard: 'Басқару панелі',
    map: 'Карта',
    calendar: 'Күнтізбе',
    analytics: 'Аналитика',
    search: 'Іздеу',
    notifications: 'Хабарламалар',
    location: 'Орналасқан жер',
    incidents: 'Оқиғалар',
    archive: 'Мұрағат',
    monitoring: 'Мониторинг',
    sensorManagement: 'Датчиктерді басқару',
    sensors: 'Датчиктер',
    sensorHealth: 'Датчик күйі',
    events: 'Оқиғалар',
    trafficManagement: 'Қозғалысты басқару',
    trafficLogs: 'Жол қозғалысы журналдары',
    trafficEvents: 'Жол қозғалысы оқиғалары',
    trafficViolations: 'Жол қозғалысы ережелерін бұзу',
    seatbeltViolations: 'Қауіпсіздік белдігі бұзушылықтары',
    seatbeltEvents: 'Қауіпсіздік белдігі оқиғалары',
    trafficAnalytics: 'Жол қозғалысы аналитикасы',
    reports: 'Есептер',
    administration: 'Әкімшілік',
    users: 'Пайдаланушылар',
    userRoles: 'Пайдаланушы рөлдері',
    account: 'Аккаунт',
    profile: 'Профиль',
    profileSettings: 'Профиль параметрлері',
    system: 'Жүйе',
    systemHealth: 'Жүйе күйі',
    integrations: 'Интеграциялар',
    translations: 'Аудармалар',
    storage: 'Сақтау орны',
    backups: 'Резервтік көшірмелер',
    license: 'Лицензия',
    help: 'Көмек',
    queueManager: 'Кезек менеджері',
    workers: 'Жұмысшылар',
  },

  // Add header translations
  header: {
    expandSidebar: 'Бүйірлік панельді кеңейту',
    collapseSidebar: 'Бүйірлік панельді жию',
    language: 'Тілді өзгерту',
    selectLanguage: 'Тілді таңдаңыз',
    recentNotifications: 'Соңғы хабарландырулар',
    notificationTitle: 'Жүйелік ескерту',
    notificationDesc: 'Жаңа жүйелік ескерту сіздің назарыңызды қажет етеді.',
    help: 'Көмек',
    toggleTheme: 'Тақырыпты ауыстыру',
  },

  // Add new sensor health translations
  sensorHealth: {
    dashboard: 'Сенсор күйі тақтасы',
    overview: 'Сенсор күйінің шолуы',
    details: 'Сенсор мәліметтері',
    loading: 'Сенсор жүктелуде...',
    error: 'Сенсорды жүктеу қатесі',
    notFound: 'Сенсор табылмады',
    sensorNotFound: '{{id}} идентификаторы бар сенсор табылмады',
    editSensor: 'Сенсорды өңдеу',
    alerts: 'Хабарландырулар',
    metrics: {
      uptime: 'Жұмыс уақыты',
      signalStrength: 'Сигнал күші',
      batteryLevel: 'Батарея деңгейі',
      responseTime: 'Жауап уақыты',
      dataRate: 'Деректер жылдамдығы',
      temperature: 'Температура',
      humidity: 'Ылғалдылық',
      errorRate: 'Қате деңгейі',
      packetLoss: 'Пакет жоғалту',
      connectionStatus: 'Қосылу күйі',
      operationalStatus: 'Жұмыс күйі',
      firmwareVersion: 'Микропрограмма нұсқасы',
      hardwareVersion: 'Аппараттық нұсқа',
      lastCalibration: 'Соңғы калибрлеу',
      selfTestStatus: 'Өзін-өзі тексеру күйі',
      lastUpdated: 'Соңғы жаңарту',
    },
    status: {
      online: 'Онлайн',
      offline: 'Оффлайн',
      warning: 'Ескерту',
      error: 'Қате',
      maintenance: 'Қызмет көрсету',
      all: 'Барлық сенсорлар',
      connected: 'Қосылған',
      disconnected: 'Ажыратылған',
      intermittent: 'Үздіксіз',
      active: 'Белсенді',
      idle: 'Бос',
    },
    metricsData: {
      batteryLevel: 'Батарея деңгейі',
      signalStrength: 'Сигнал күші',
      uptime: 'Жұмыс уақыты',
      responseTime: 'Жауап уақыты',
      dataRate: 'Деректер жылдамдығы',
      temperature: 'Температура',
      humidity: 'Ылғалдылық',
      lastUpdated: 'Соңғы жаңарту',
    },
    alertsData: {
      title: 'Хабарландырулар',
      noAlerts: 'Хабарландырулар жоқ',
      lowBattery: 'Төмен батарея',
      signalLoss: 'Сигнал жоғалту',
      highTemperature: 'Жоғары температура',
      maintenance: 'Қызмет көрсету қажет',
      severity: {
        low: 'Төмен',
        medium: 'Орташа',
        high: 'Жоғары',
        critical: 'Критикалық',
      },
      status: {
        active: 'Белсенді',
        resolved: 'Шешілген',
        acknowledged: 'Расталған',
        ignored: 'Елемеу',
      },
    },
    diagnostics: {
      title: 'Диагностика',
      selfTest: 'Өзін-өзі тексеру',
      passed: 'Өтті',
      failed: 'Сәтсіз',
      voltage: 'Кернеу',
      memory: 'Жад қолданылуы',
      cpu: 'Процессор қолданылуы',
      errorCodes: 'Қате кодтары',
    },
    performance: {
      title: 'Өнімділік',
      excellent: 'Өте жақсы',
      good: 'Жақсы',
      fair: 'Орташа',
      poor: 'Нашар',
      packetLoss: 'Пакет жоғалтуы',
      latency: 'Кідіріс',
      jitter: 'Діріл',
      throughput: 'Өткізу қабілеті',
    },
    filter: {
      searchPlaceholder: 'Сенсорларды іздеу...',
      filterByStatus: 'Күй бойынша сүзу',
      applyFilters: 'Сүзгілерді қолдану',
      resetFilters: 'Сүзгілерді өшіру',
      sortBy: 'Сұрыптау',
    },
    actions: {
      viewDetails: 'Толық көру',
      refreshData: 'Деректерді жаңарту',
      exportData: 'Деректерді экспорттау',
      createAlert: 'Хабарландыру жасау',
      scheduleMaintenence: 'Қызмет көрсетуді жоспарлау',
      resetSensor: 'Сенсорды қалпына келтіру',
    },
    healthLog: {
      title: 'Күй журналы',
      noData: 'Күй журналы деректері қолжетімді емес',
      noLogsReceived: 'Бұл сенсордан күй журналы жазбалары алынбаған',
      deviceStatus: 'Құрылғы күйі',
      radarStatus: 'Радар күйі',
      cameraStatus: 'Камера күйі',
      gpsStatus: 'GPS күйі',
      ledStatus: 'LED күйі',
      latestStatus: 'Соңғы күй туралы қысқаша мәлімет',
      systemHealth: 'Жүйе күйі',
      allSystemsOperational: 'Барлық жүйелер жұмыс істеуде',
      systemIssuesDetected: 'Жүйеде мәселелер анықталды',
      lastStatusUpdate: 'Соңғы күй жаңартуы',
    },
  },

  // Бос күйлер - Иллюстрациялармен ақпараттық хабарламалар
  emptyStates: {
    // Сенсорлар
    noSensors: {
      title: 'Сенсорлар табылмады',
      description: 'Трафикті бақылау және деректерді жинау үшін бірінші сенсорды қосудан бастаңыз.',
      primaryAction: 'Сенсор қосу',
      secondaryAction: 'Толығырақ',
    },
    noSensorsFiltered: {
      title: 'Сәйкес сенсорлар жоқ',
      description:
        'Ағымдағы сүзгі критерийлеріне сәйкес сенсорлар жоқ. Сүзгілерді немесе іздеу шарттарын өзгертіп көріңіз.',
      primaryAction: 'Сүзгілерді тазарту',
    },

    // Орналасқан жерлер
    noLocations: {
      title: 'Орналасқан жерлер табылмады',
      description:
        'Сенсорларды ұйымдастыру және белгілі аймақтарда трафикті бақылау үшін орналасқан жерлерді қосыңыз.',
      primaryAction: 'Орын қосу',
      secondaryAction: 'Орындарды импорттау',
    },
    noLocationsFiltered: {
      title: 'Сәйкес орындар жоқ',
      description:
        'Іздеуге сәйкес орындар жоқ. Басқа іздеу терминін қолданып көріңіз немесе барлық орындарды қараңыз.',
      primaryAction: 'Іздеуді тазарту',
    },

    // Оқиғалар
    noEvents: {
      title: 'Оқиғалар табылмады',
      description:
        'Сенсорлар белсенділікті анықтай бастағанда жол қозғалысы оқиғалары осы жерде пайда болады. Сенсорларыңыздың желіде және дұрыс конфигурацияланғанын тексеріңіз.',
      primaryAction: 'Сенсорларды тексеру',
      secondaryAction: 'Жаңарту',
    },
    noEventsFiltered: {
      title: 'Сәйкес оқиғалар жоқ',
      description:
        'Ағымдағы сүзгілерге сәйкес оқиғалар жоқ. Күн аралығын, сүзгі критерийлерін өзгертіп немесе сенсор қосылымын тексеріп көріңіз.',
      descriptionWithQuery:
        '«{{query}}» сұрауына сәйкес оқиғалар жоқ. Басқа іздеу терминдерін қолданып, күн аралығын өзгертіп немесе сүзгі критерийлерін тексеріп көріңіз.',
      descriptionWithEventId: '«{{query}}» ID бар оқиға табылмады. Оқиға ID дұрыстығын тексеріңіз.',
      primaryAction: 'Сүзгілерді тазарту',
      secondaryAction: 'Жаңарту',
    },

    // Бұзушылықтар
    noViolations: {
      title: 'Бұзушылықтар табылмады',
      description:
        'Ағымдағы сүзгілерге сәйкес бұзушылықтар жоқ. Күн аралығын немесе бұзушылық түрін өзгертіп көріңіз.',
      primaryAction: 'Сүзгілерді реттеу',
      secondaryAction: 'Жаңарту',
    },

    // Қауіпсіздік белбеуі бұзушылықтары
    noSeatbeltViolations: {
      title: 'Қауіпсіздік белбеуі бұзушылықтары жоқ',
      description:
        'Сенсорлар оларды анықтай бастағанда қауіпсіздік белбеуі бұзушылықтары осы жерде пайда болады. Сенсорларыңыздың желіде екенін және қауіпсіздік белбеуі бұзушылықтарын анықтауға конфигурацияланғанын тексеріңіз.',
      primaryAction: 'Сенсорларды тексеру',
      secondaryAction: 'Жаңарту',
    },
    noSeatbeltViolationsFiltered: {
      title: 'Сәйкес бұзушылықтар жоқ',
      description:
        'Ағымдағы сүзгілерге сәйкес қауіпсіздік белбеуі бұзушылықтары жоқ. Күн аралығын, сүзгі критерийлерін өзгертіп немесе іздеу параметрлерін кеңейтіп көріңіз.',
      descriptionWithQuery:
        '«{{query}}» сұрауына сәйкес қауіпсіздік белбеуі бұзушылықтары жоқ. Басқа іздеу терминдерін қолданып, күн аралығын өзгертіп немесе сүзгі критерийлерін тексеріп көріңіз.',
      descriptionWithEventId:
        '«{{query}}» ID бар қауіпсіздік белбеуі бұзушылығы табылмады. Оқиға ID дұрыстығын тексеріңіз.',
      primaryAction: 'Сүзгілерді тазарту',
      secondaryAction: 'Жаңарту',
    },

    // Есептер
    noReports: {
      title: 'Есептер әлі жоқ',
      description:
        'Жол қозғалысы үлгілерін, сенсор деректерін және уақыт бойынша бұзушылықтарды талдау үшін теңшелетін есептерді жасаңыз.',
      primaryAction: 'Есеп жасау',
      secondaryAction: 'Үлгілерді қарау',
    },

    // Хабарландырулар
    noNotifications: {
      title: 'Хабарландырулар жоқ',
      description:
        'Сіз барлық хабарларды оқыдыңыз! Белсенділік болған кезде жаңа хабарландырулар осы жерде пайда болады.',
      primaryAction: 'Хабарландыру параметрлері',
    },
    allNotificationsRead: {
      title: 'Барлығы оқылды!',
      description: 'Сізде оқылмаған хабарландырулар жоқ.',
      primaryAction: 'Барлығын көру',
    },

    // Іздеу нәтижелері
    noSearchResults: {
      title: 'Нәтижелер табылмады',
      description:
        'Ештеңе табылмады. Басқа кілт сөздерді қолданып көріңіз немесе іздеуді кеңейтіңіз.',
      descriptionWithQuery:
        '«{{query}}» сұрауы бойынша ештеңе табылмады. Басқа кілт сөздерді қолданып көріңіз немесе емлені тексеріңіз.',
      primaryAction: 'Іздеуді тазарту',
      secondaryAction: 'Сүзгілерді реттеу',
      tipsTitle: 'Іздеу бойынша кеңестер',
      tips: {
        checkSpelling: 'Емлені тексеріп, қайталап көріңіз',
        useKeywords: 'Жалпы кілт сөздерді қолданыңыз',
        removeFilters: 'Іздеуді кеңейту үшін кейбір сүзгілерді алып тастаңыз',
        tryDifferentTerms: 'Басқа іздеу терминдерін қолданып көріңіз',
      },
    },

    // Мұрағат
    noArchive: {
      title: 'Мұрағатталған оқиғалар жоқ',
      description:
        'Оқиғалар сақтау саясатына сәйкес автоматты түрде мұрағатталады. Мұрағатталған оқиғалар белсенді дерекқорды оңтайландыру кезінде сәйкестік және тарихи талдау үшін сақталады.',
      primaryAction: 'Сақтау саясатын конфигурациялау',
      secondaryAction: 'Толығырақ',
    },
    noArchiveFiltered: {
      title: 'Сәйкес мұрағатталған оқиғалар жоқ',
      description:
        'Ағымдағы сүзгілерге сәйкес мұрағатталған оқиғалар жоқ. Күн аралығын, оқиға түрін немесе маңыздылық деңгейін өзгертіп көріңіз.',
      descriptionWithQuery:
        '«{{query}}» сұрауына сәйкес мұрағатталған оқиғалар жоқ. Басқа іздеу терминдерін қолданып көріңіз немесе сүзгі критерийлерін реттеңіз.',
      primaryAction: 'Сүзгілерді тазарту',
      secondaryAction: 'Жаңарту',
    },

    // Жалпы деректер жоқ
    noData: {
      title: 'Деректер қолжетімді емес',
      description:
        'Қазіргі уақытта көрсетілетін деректер жоқ. Кейінірек тексеріңіз немесе жаңартып көріңіз.',
      primaryAction: 'Жаңарту',
    },
  },
};

export default translations;
